let prevAction = "init";
let staticEventLists = [];
let sendImmediate = false;
let immediateSendEvent = ["login_fail"];

export const judgeIsNewUser = function(id) {
  if (!id) {
    return true;
  }
  let firstPlayObj = JSON.parse(
    window.localStorage.getItem("firstPlayObj") || "{}"
  );
  let playerInfo = firstPlayObj[id];
  let firstTime = Date.now();
  if (playerInfo) {
    firstTime = playerInfo.firstPlayTime;
  }
  let date = new Date(firstTime);
  let now = Date.now();
  let playTime = Math.floor((now - date.getTime()) / (60 * 60 * 1000));
  let isNew = playTime < 48 ? true : false;
  return isNew;
};

export default {
  state: {},
  actions: {
    gaStatistics({ rootState }, { eventName, data = {} }) {
      console.log(`打点${eventName}`);
      console.log(data);
      let isNewUser = judgeIsNewUser(rootState.user.user.id);
      let gadata = {
        event: eventName,
        is_new: isNewUser,
        prev: prevAction,
        time: window.now_time || new Date().getTime(),
        userName: rootState.user.user.name,
        ...data
      };
      staticEventLists.push(gadata);
      if (eventName === "click_close_window") {
        sendImmediate = true;
      }
      if (immediateSendEvent.indexOf(eventName) !== -1) {
        sendImmediate = true;
      }
      if (sendImmediate) {
        // 重置队列推入的打点归属
        staticEventLists = staticEventLists.map(item => {
          item.userName = rootState.user.user.name;
          item.is_new = isNewUser;
          return item;
        });
        if (immediateSendEvent.indexOf(eventName) !== -1) {
          sendImmediate = false;
        }
        if (window.dataLayer) {
          staticEventLists = staticEventLists.filter(item => !item.isSend);
          let length = staticEventLists.length;
          if (!length) {
            return;
          }
          for (let i = 0; i < length; i++) {
            let item = staticEventLists[i];
            let isSend = item.isSend;
            if (isSend) {
              continue;
            }
            window.dataLayer.push(item);
            item.isSend = true;
          }
        }
      }
      if (eventName === "login_success") {
        sendImmediate = true;
      }

      prevAction = eventName;
    },
    gaStatisticsCommon({}, { eventName, data = {} }) {
      window.dataLayer.push({
        event: eventName,
        ...data
      });
    },
    setIsFirstPlay({ rootState }, val) {
      let firstPlayObj = JSON.parse(
        window.localStorage.getItem("firstPlayObj") || "{}"
      );
      if (!val) {
        val = false;
      }
      if (firstPlayObj[rootState.user.user.id]) {
        val = judgeIsNewUser();
      }
      // 根据isFirst区别设置firstTime
      let tmpFirstTime = val ? Date.now() : Date.now() - 48 * 60 * 60 * 1000;
      firstPlayObj.prev = rootState.user.user.id;
      firstPlayObj[rootState.user.user.id] = {
        isFirst: val,
        firstPlayTime:
          (firstPlayObj[rootState.user.user.id] &&
            firstPlayObj[rootState.user.user.id].firstPlayTime) ||
          tmpFirstTime
      };
      this.isFirstPlay = val;
      window.localStorage.setItem("firstPlayObj", JSON.stringify(firstPlayObj));
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/ga.js